import * as type from '../types/payment_movies';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestPaymentMovies = actionCreator(type.REQUEST_PAYMENT_MOVIES);
export var successPaymentMovies = actionCreator(type.SUCCESS_PAYMENT_MOVIES);
export var failurePaymentMovies = actionCreator(type.FAILURE_PAYMENT_MOVIES);